const json = {
    GE: {
        TITLES: [
            'ტოპ 5 ღვინო, რომელმაც დაიპყრო ტურისტების გულები',
            'ტოპ 5 ქართული კერძი, რომელიც ყველაზე ხშირად დაიდო ინსტაგრამზე',
            'ტოპ 5 ყველაზე ხშირად დათაგული შენობა თბილისში',
            'ტოპ 7 ყველაზე ხშირად მონახულებული ლოკაცია თვეების მიხედვით'
        ],
        POLICIES: [
            'მონაცემები გენერირებულია 7 მილიონი ტურისტის მიერ სოციალურ მედიებში გაზიარებული პოსტებიდან.',
            'გულწრფელი, ადამიანური ემოციები ხელოვნური ინტელექტის დახმარებითაა გაანალიზებული.'
        ]
    },
    EN: {
        TITLES: [
            'Top 5 wines that captivated tourist\'s hearts and made them post on social media',
            'Top 5 most instagramed Georgian dishes',
            'Top 5 most frequently tagged buildings in Tbilisi',
            'Top 7 most checked in locations by month'
        ],
        POLICIES: [
            'This data is generated from social media posts shared by 7 million tourists.',
            'Genuine human emotions were selected and analyzed by artificial intelligence.'
        ]
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/statistics/statistics.texts.js